export default "__VITE_ASSET__CTW53Ewx__"